import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { withStyles, makeStyles } from "@material-ui/core/styles";

export default function InfoToolTip(props) {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = (event) => {
    if (event?.stopPropagation) {
      event.stopPropagation();
    }
    setOpen(true);
  };

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#fff",
      color: "rgba(0, 0, 0, 0)",
      maxWidth: 220,
      boxShadow: "0px 2px 4px lightGray",
    },
    arrow: {
      color: "#fff",
    },
  }))(Tooltip);

  let arrayObj = [];

  if (Array.isArray(props.data)) {
    for (const obj of props.data) {
      arrayObj.push({ name: obj.split('-')[0], value: props.data[obj] });
    }
  } else {
    for (const obj in props.data) {
      arrayObj.push({ name: obj.split('-')[0], value: props.data[obj] });
    }
  }
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <HtmlTooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="top"
          arrow
          title={
            <React.Fragment>
              <Typography style={{ color: "#333" }}>
                {props?.title || ""}
              </Typography>
              <br />
              {arrayObj.map((ele) => (
                <p
                  key={ele.name}
                  style={{
                    fontWeight: "bold",
                    fontVariant: "small-caps",
                    color: "#333",
                    fontSize: "14px",
                    lineHeight: "12px",
                  }}
                >
                  {ele.name} : ₹ {Number(ele.value).toFixed(2)}
                </p>
              ))}
            </React.Fragment>
          }
        >
          <InfoOutlinedIcon
            color="primary"
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={handleTooltipOpen}
            onMouseOver={(e) => (props?.hover ? handleTooltipOpen(e) : {})}
            onMouseOut={(e) => (props?.hover ? handleTooltipClose(e) : {})}
          />
        </HtmlTooltip>
      </div>
    </ClickAwayListener>
  );
}
